<header class="header-wrapper">
  <div class="container">
    <h1 class="title text-start">{{contentTitle}}</h1>
    <p class="info text-start">{{contentDescription}}</p>
  </div>
</header>